import { type FullBudgetMixResponse } from "@north-beam/nb-common";
import { Modal } from "@shared/modal";

import { type Kpi } from "../../client-setting/types";
import { ScenarioModelingContent } from "../../scenario-modeling/scenario-modeling-content";

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  budgetMix: FullBudgetMixResponse;
  inheritedClientSettingKpi: Kpi | null | undefined;
};

export const BudgetMixForecastModal = ({
  isOpen,
  closeModal,
  budgetMix,
  inheritedClientSettingKpi,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onClose={closeModal}
    size="2xl"
    hideCloseButton
    bodyClassName="p-0"
  >
    <div className="absolute right-0 top-0 mx-6 my-3">
      <button onClick={closeModal}>
        <i className="fa-regular fa-sharp fa-xmark font-bold text-xl" />
      </button>
    </div>
    <ScenarioModelingContent
      budgetMix={budgetMix}
      inheritedClientSettingKpi={inheritedClientSettingKpi}
    />
  </Modal>
);
